import usersService from '@/services/users'
import toastr from 'toastr'

const state = {
   cmsConfigHomepageDto: [],
   sitesCount: 0,
   departmentCount: 0,
   departments: []
}

const getters = {
   getCmsConfigHomepage () {
      return state.cmsConfigHomepageDto
   },
   getTotalSitesOnChain () {
      return state.sitesCount
   },
   getDepartments () {
      return state.departments
   },
   getDepartmentCount () {
      return state.departmentCount
   }
}

const mutations = {
   setCmsConfigHomepageDto (state, value) {
      state.cmsConfigHomepageDto = value
   },
   setSiteCount (state, value) {
      state.sitesCount = value
   },
   setDepartments (state, value) {
      state.departments = value
   },
   setDepartmentCount (state, value) {
      state.departmentCount = value
   },
}

const actions = {
   getCmsConfigByChainId (context, queryParams) {
      return usersService.GetCmsConfigByChainId(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {
            return resp.Dto
         } else {
            toastr.error('Kunne ikke oppdatere hjemmeside-konfigurasjon. Vennligst prøv igjen senere. Mest sannsynling må det legges en linje i CMS_Config tabellen for denne salongen', 'Noe gikk galt!')
            return undefined
         }
      })
   },
   async getAllHomepageCmsConfigsByChainId ({ commit }, queryParams) {
      return usersService.GetAllHomepageCmsConfigsByChainId(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {
            commit('setCmsConfigHomepageDto', resp.CmsConfigHomepageDtoResponse)
            return true
         } else {
            toastr.error('Kunne ikke hente hjemmeside-konfigurasjon. Vennligst prøv igjen senere. Mest sannsynling må det legges en linje i CMS_Config tabellen for denne salongen', 'Noe gikk galt!')
            return false
         }
      })
   },
   async createNewHomepage ({ commit }, queryParams) {
      return usersService.CreateNewHomepage(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {

            return true
         } else {
            toastr.error('Kunne ikke opprette ny hjemmeside', 'Noe gikk galt!')
            return false
         }
      })
   },
   async getDepartmentsByChainId ({ commit }, queryParams) {
      return usersService.GetDepartmentsByChainId(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {
            commit('setDepartments', resp.Array)
            commit('setDepartmentCount', resp.TotalSize)
            return true
         } else {
            toastr.error('Kunne ikke hente avdelingene i kjeden', 'Noe gikk galt!')
            return false
         }
      })
   },
   async getNumberOfSitesInChain ({ commit }, queryParams) {
      return usersService.GetNumberOfSitesInChain(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {
            commit('setSiteCount', resp.Value)
            return true
         } else {
            toastr.error('Kunne ikke hente hjemmeside-konfigurasjon. Vennligst prøv igjen senere. Mest sannsynling må det legges en linje i CMS_Config tabellen for denne salongen', 'Noe gikk galt!')
            return false
         }
      })
   },
   setCurrentSiteId (context, queryParams) {
      return usersService.SetCurrentSiteId(queryParams).then(function (response) {
         if (response.BooleanValue) {
            return true
         } else {
            toastr.error('Vennligst prøv igjen', 'Endring mislyktes!')
            return null
         }
      })
   },
   async DeleteHomepageCmsConfig (context, queryParams) {
      return usersService.DeleteHomepageCmsConfig(queryParams).then(function (resp) {
         if (resp.ResponseCode === 200) {
            return true
         } else {
            toastr.error('Kunne ikke slette hjemmesiden', 'Noe gikk galt!')
            return false
         }
      })
   },
}

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}
